document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mega-menu-image-block').forEach(function (block) {
    const parentTitle = block.getAttribute('link-title')?.trim().toLowerCase();

    block.querySelectorAll('.menu-image-wrap[block-link-title]').forEach(function (anchor) {
      const linkTitle = anchor.getAttribute('block-link-title')?.trim().toLowerCase();
      if (linkTitle !== parentTitle) {
        anchor.remove();
      }
    });
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const stockInfo = document.getElementById('variant-stock-info');
  const selectedOptionsDiv = document.getElementById('variant-selected-options');
  const customPopup = document.querySelector('.custom-product-popup');
  const addToCartWrapper = document.querySelector('.custom-product-popup-buy-button');
  const addToCartButton = addToCartWrapper?.querySelector('button.add-to-cart-button');
  const addToCartText = addToCartButton?.querySelector('.add-to-cart-text__content');
  const addToCartIcon = addToCartButton?.querySelector('.add-to-cart-icon');
  const variantPriceDetails = document.getElementById('variant-price-details');
  const originalProductPrice = document.querySelector('#product-price > div');
  const popUpModalTitle = document.getElementById('popup-modal-title');
  const popUPbutton = document.querySelector('.custom-product-popup .popup-link__button');

const buttonText = Array.from(popUPbutton.childNodes)
                        .filter(node => node.nodeType === Node.TEXT_NODE)
                        .map(node => node.textContent.trim())
                        .join('');

 
  function disableAddToCart() {
    if (!addToCartButton) return;
    addToCartButton.disabled = true;
    addToCartButton.classList.add('disabled');
    if (addToCartText) addToCartText.textContent = 'Please select a store';
    if (addToCartIcon) addToCartIcon.style.display = 'none';
  }

  function enableAddToCart() {
    if (!addToCartButton) return;
    addToCartButton.disabled = false;
    addToCartButton.classList.remove('disabled');
    if (addToCartText) addToCartText.textContent = 'Add to cart';
    if (addToCartIcon) addToCartIcon.style.display = '';
  }

 
  function handleStoreSelection() {
    const storeRadios = document.querySelectorAll('#variant-stock-info input[name="store"]');
    const selected = Array.from(storeRadios).some(radio => radio.checked);
    selected ? enableAddToCart() : disableAddToCart();
  }

  
  function attachStoreListeners() {
    const storeRadios = document.querySelectorAll('#variant-stock-info input[name="store"]');
    if (!storeRadios.length) return;
    storeRadios.forEach(radio => radio.addEventListener('change', handleStoreSelection));
    handleStoreSelection();
  }

  disableAddToCart();
  attachStoreListeners();

  const stockObserver = new MutationObserver(() => attachStoreListeners());
  if (stockInfo) stockObserver.observe(stockInfo, { childList: true, subtree: true });

  
  function cloneProductPrice() {
    if (!originalProductPrice || !variantPriceDetails) return;
    variantPriceDetails.innerHTML = '';
    const clonedPrice = originalProductPrice.cloneNode(true); // exact clone with children
    variantPriceDetails.appendChild(clonedPrice);
  }


  if (originalProductPrice) {
    const priceObserver = new MutationObserver(() => {
      cloneProductPrice(); // update cloned price whenever original changes
    });
    priceObserver.observe(originalProductPrice, { childList: true, subtree: true, characterData: true });
  }

  // ---- Initial clone on page load ----
  cloneProductPrice();

  // ---- Variant change handler ----
  const productSelect = document.querySelector('[name="id"]');
  if (productSelect) {
    productSelect.addEventListener('change', async (e) => {
      const variantId = e.target.value;
      if (!variantId) return;

      try {
        const res = await fetch(`${window.location.pathname}?variant=${variantId}&section_id=variant-stock-info`);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        // Update stock info
        const newStock = doc.querySelector('#variant-stock-info');
        if (newStock && stockInfo) stockInfo.innerHTML = newStock.innerHTML;
        attachStoreListeners();

        // Update price
        const newPrice = doc.querySelector('#product-price');
        if (newPrice && variantPriceDetails) {
          variantPriceDetails.innerHTML = '';
          const clonedPrice = newPrice.cloneNode(true);
          variantPriceDetails.appendChild(clonedPrice);
        }

        // Update Title
        popUpModalTitle.innerHTML = buttonText;

      } catch (err) {
        console.error('Variant update failed', err);
      }
    });
  }

  // ---- BCPO option observer ----
  function updateSelectedOption() {
    const optionRadios = document.querySelectorAll('.bcpo-front-button-option');
    let selectedValues = [];
    let disablePopup = false;

    optionRadios.forEach(radio => {
      if (radio.checked) {
        selectedValues.push(radio.value);
        if (radio.closest('.bcpo-disabled')) disablePopup = true;
      }
    });

    if (selectedOptionsDiv) selectedOptionsDiv.innerHTML = selectedValues.join(', ');
    if (customPopup) customPopup.style.display = disablePopup ? 'none' : '';
  }

  const bcpoObserver = new MutationObserver(() => {
    const optionRadios = document.querySelectorAll('.bcpo-front-button-option');
    if (optionRadios.length) {
      optionRadios.forEach(radio => radio.addEventListener('change', updateSelectedOption));
      updateSelectedOption();
      bcpoObserver.disconnect();
    }
  });
  bcpoObserver.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('click', function(e) {
  // console.log('dialoge---click')
  if (e.target.closest('.add-to-cart-button')) {
    const dialog = document.querySelector('.custom-product-popup');
    //  console.log('dialoge---',dialog);
    if (dialog) dialog.closeDialog();
  }
});